import React, { useEffect, useState } from "react";
import { Button, Empty, Select } from "antd";

import Table from "../Table";
import "./qsetjd.scss";
import useQSetStore from "../../store/qset.store";
import QSETViewJD from "../QsetViewJD";
import { GetOwnership } from "../../helper/commonFunctions";

export default function QSETViewJDPage(props) {
  const qsetUserDetails = JSON.parse(localStorage.getItem("qsetUserDetails"));
  const { myJdArray, myApplication, myResume, myEval } = useQSetStore();
  useEffect(() => {}, []);

  const titleList = [
    "Sr. No.",
    "Applied On",
    "Application Mode", //Self,HR
    "Job Designation",
    "Job Title",
    "Payroll",
    "HR Name",
    "HR Email",
    "HR Phone",
  ];
  console.log("myJdArray", myJdArray);

  const jdsDetailData = myJdArray?.map((jds, idx) => {
    var sOwner = GetOwnership(myResume);
    return {
      id: idx + 1,
      date_added: sOwner.sourceDate,
      addedby: "Added By HR",
      designation: jds?.JDDetails.Designation,
      title: "[" + jds?.QhCompanyJID + "] " + jds?.JDDetails.Title,
      client_name: qsetUserDetails.companyname.replaceAll("+", " "),
      SPOC: jds?.JDAssignment?.Assignments[0].AssignedToName,
      Email: jds?.JDAssignment?.Assignments[0].AssignedToEmail,
      Phone: jds?.JDAssignment?.Assignments[0].AssignedToPhone,
    };
  });

  return (
    <div className="qsetViewJD-wrapper">
      <div className="teamTask-title">
        JD of My Application ({myJdArray?.length}){" "}
      </div>
      {console.log("my application", myApplication)}
      {myJdArray?.length > 0 ? (
        <QSETViewJD
          jd={myJdArray?.[0]}
          qsetUserDetails={qsetUserDetails}
          appliedOn={jdsDetailData?.[0]?.date_added}
          applicationMode={jdsDetailData?.[0]?.addedby}
        />
      ) : (
        <Empty style={{ margin: "60px" }} />
      )}
    </div>
  );
}
